import { render, staticRenderFns } from "./ConvenzioniList.vue?vue&type=template&id=504ebb59&"
import script from "./ConvenzioniList.vue?vue&type=script&lang=js&"
export * from "./ConvenzioniList.vue?vue&type=script&lang=js&"
import style0 from "./ConvenzioniList.vue?vue&type=style&index=0&id=504ebb59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports